export default class ObjectUtils {
  static hasPropertyWithValue(obj, property) {
    if (obj === null || obj === undefined) {
      return false;
    }
    return (property in obj) && !(obj[property] === null);
  }
} 
